import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Actions as articleActions,
  Creators as articleCreators,
} from "../../core/redux/ducks/article";
import {
  Actions as folderActions,
  Creators as folderCreators,
} from "../../core/redux/ducks/folder";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Container, Box, Button } from "@material-ui/core";
import { ArticleCard } from "./ArticleCard";
import { Loading } from "../../components/Loading";
import { FoldersSidebar } from "./FoldersSidebar";
import { ConfirmModal } from "./ConfirmModal";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { ArticleModalView } from "./ArticleModalView";
import styled from "styled-components";
import { FormFolderModal } from "../../components/FormFolderModal";
import { Actions as reportActions } from "../../core/redux/ducks/report";
import { ReportCard } from "../dashboard/ReportCard";
import uuid from "react-uuid";
import { useSearchContext } from "../../contexts/Search";
import useLanguage from "../../hooks/useLanguage";
import { useHistory } from "react-router-dom";
const defaultFolder = {
  id: 0,
  name: "",
  articles: [],
  updatedAt: "",
  createdAt: "",
  subFolder: null,
  parentFolder: null,
};

export const ArticlesManager = () => {
  const [articleList, setArticleList] = useState([]);
  const [selectedFolder, selectFolder] = useState(defaultFolder);
  const [selectedSubFolder, selectSubFolder] = useState(defaultFolder);
  const { language } = useLanguage();
  const { translate } = language;
  const [title, setTitle] = useState(translate.drafts_title);
  const [modalShow, setModalShow] = React.useState(false);
  const [parentFolder, setParentFolder] = React.useState(0);
  // const [modalShowConfirm, setModalShowConfirm] = React.useState(false);
  const [modalShowConfirmFolder, setModalShowConfirmFolder] = React.useState({
    open: false,
    folder: defaultFolder,
  });
  const [articleModalShow, setArticleModal] = React.useState(false);
  const [showMore, setShowMore] = React.useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const articlesState = useSelector((state) => state.article);
  const folderState = useSelector((state) => state.folder);
  const { folders, loading: loadingFolders } = folderState;
  const { articles, loading } = articlesState;
  const fetchArticles = () => articleActions.fetchArticles(dispatch);
  const fetchFolders = () => folderActions.fetchFolders(dispatch);
  const addFolder = (params) => folderActions.addFolder(dispatch, params);
  const deleteFolder = (id) => folderActions.deleteFolder(dispatch, id);
  const addFolderArticle = (article, folderId) =>
    folderActions.addFolderArticle(dispatch, article, folderId);
  const removeArticle = (articleId) =>
    dispatch(articleCreators.removeArticle(articleId));
  const removeArticleFolder = (folderId, articleId) =>
    dispatch(folderCreators.removeArticleFolder(folderId, articleId));
  const setArticle = (selectedArticle) => {
    dispatch(articleCreators.addArticleSuccess(selectedArticle, ""));
  };
  const history = useHistory();

  const { reports, loading: loadingFeed } = useSelector(
    (state) => state.report
  );

  const { user } = useSelector((state) => state.user);

  const fetchReports = () =>
    reportActions.fetchReports(dispatch, { pagesize: 12, keywords: "" });

  useEffect(() => {
    fetchArticles();
    fetchFolders();
    fetchReports();
  }, []);

  useEffect(() => {
    fetchFolders();
    setArticleList(articles);
  }, [articles]);

  useEffect(() => {
    if (selectedFolder.id) setArticleList(selectedFolder.articles);
  }, [selectedFolder]);

  useEffect(() => {
    if (selectedFolder.id)
      selectFolder(folders.find((folder) => folder.id === selectedFolder.id));
  }, [folders]);

  useEffect(() => {
    setTitle(translate.drafts_title);
  }, [translate]);

  useEffect(() => {
    setArticleList(selectedSubFolder.articles);
    if (selectedSubFolder.name) setTitle(selectedSubFolder.name);
  }, [selectedSubFolder]);
  const { searchText } = useSearchContext();

  useEffect(() => {
    const newArticles = articles.filter((article) =>
      article?.name.toLocaleLowerCase().includes(searchText)
    );
    setArticleList(newArticles);
  }, [searchText]);

  function handleAddFolder(params) {
    addFolder(params);
  }

  const setRootFolder = () => {
    setArticleList(articles);
    setTitle(translate.drafts_title);
    selectFolder(defaultFolder);
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination, draggableId } = result;
    if (
      source.droppableId !== destination.droppableId &&
      destination.droppableId.includes("column-folder-")
    ) {
      const folderId = parseInt(
        destination.droppableId.replace("column-folder-", "")
      );
      const movedArticle = articleList.find(
        (articleSearch) => articleSearch.id === parseInt(draggableId)
      );
      addFolderArticle(movedArticle, folderId);
      if (selectedFolder.id) {
        removeArticleFolder(selectedFolder.id, movedArticle.id);
      } else {
        removeArticle(movedArticle.id);
      }
    }
  };

  return (
    <div className={classes.root}>
      <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
        <FoldersSidebar
          folders={folders}
          loading={loadingFolders}
          setArticleList={setArticleList}
          selectFolder={selectFolder}
          selectedFolder={selectedFolder}
          selectSubFolder={selectSubFolder}
          selectedSubFolder={selectedSubFolder}
          setTitle={setTitle}
          openModal={() => setModalShow(true)}
          openDeleteModal={(folder) =>
            setModalShowConfirmFolder({ open: true, folder: folder })
          }
          setRootFolder={setRootFolder}
          setParentFolder={setParentFolder}
        />
        <div className={classes.body}>
          <Container className={classes.container}>
            {!user?.isPremium && (
              <Box display="flex" justifyContent="flex-end">
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={() => history.push("pricing")}
                >
                  <Typography className={classes.buttonText}>
                    Upgrade
                  </Typography>
                </Button>
              </Box>
            )}
            <Grid container>
              <Grid item className={classes.header}>
                <Typography variant="h5" gutterBottom>
                  {title}
                </Typography>
              </Grid>
            </Grid>
            <ArticleContainer item>
              {loading ? (
                <Loading />
              ) : (
                <Droppable
                  droppableId={"column-article"}
                  key={"column-article"}
                  isDropDisabled
                >
                  {(provided) => {
                    return (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {articleList &&
                          articleList.map((article, index) => {
                            if (
                              user?.isPremium &&
                              !showMore &&
                              !selectedFolder.id
                            ) {
                              if (user.isPremium && index < 3)
                                return (
                                  <ArticleCard
                                    index={index}
                                    article={article}
                                    key={article.id}
                                    onClick={() => {
                                      setArticleModal(true);
                                      setArticle(article);
                                    }}
                                  />
                                );
                            } else {
                              return (
                                <ArticleCard
                                  index={index}
                                  article={article}
                                  key={article.id}
                                  onClick={() => {
                                    setArticleModal(true);
                                    setArticle(article);
                                  }}
                                />
                              );
                            }
                          })}
                        {provided.placeholder}
                        {user?.isPremium && !selectedFolder.id && (
                          <div
                            className={classes.showMore}
                            onClick={() => setShowMore(!showMore)}
                          >
                            <Typography className={classes.showMoreText}>
                              Show {!showMore ? "more" : "less"}
                            </Typography>
                          </div>
                        )}
                      </div>
                    );
                  }}
                </Droppable>
              )}
            </ArticleContainer>
            {user?.isPremium && !selectedFolder.id && (
              <>
                {loadingFeed ? (
                  <Loading />
                ) : (
                  <>
                    <Grid container className={classes.feedContainer}>
                      <Grid item className={classes.header}>
                        <Typography variant="h5" gutterBottom>
                          {translate.new_stories_title}
                        </Typography>
                      </Grid>
                    </Grid>
                    <div className={classes.reportsContainer}>
                      <Grid container spacing={2}>
                        {reports &&
                          !!reports.reports.length &&
                          reports.reports.map((report) => (
                            <Grid item md={4} key={uuid()}>
                              <ReportCard report={report} />
                            </Grid>
                          ))}
                      </Grid>
                    </div>
                  </>
                )}
              </>
            )}
          </Container>
        </div>
        <FormFolderModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          modalType={"Folder"}
          addFolder={handleAddFolder}
          folderData={folderState}
          parentFolder={parentFolder}
        />
        <ConfirmModal
          show={modalShowConfirmFolder.open}
          onHide={() =>
            setModalShowConfirmFolder({ open: false, folder: defaultFolder })
          }
          articleName={modalShowConfirmFolder.folder.name}
          deleteArticle={(event) => {
            event.preventDefault();
            setModalShowConfirmFolder({ open: false, folder: defaultFolder });
            selectFolder(defaultFolder);
            deleteFolder(modalShowConfirmFolder.folder.id);
          }}
        />
        <ArticleModalView
          show={articleModalShow}
          onHide={() => setArticleModal(false)}
        />
      </DragDropContext>
    </div>
  );
};

const ArticleContainer = styled(Grid)`
  max-height: calc(100vh - 150px);
  overflow: auto;
  padding: 10px 0;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    height: "100%",
  },
  container: {
    marginTop: "100px",
    height: "100%",
  },
  body: {
    flex: 1,
    overflow: "auto",
  },
  header: {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    width: "100%",
  },
  feedContainer: {
    marginTop: "10px",
  },
  reportsContainer: {
    // columns: "3 auto",
    margin: "20px 0 50px 0",
  },
  showMore: {
    marginTop: "20px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  showMoreText: {
    width: "200px",
    backgroundColor: "white",
    boxShadow: "0 2px 3px 0 rgba(0, 0, 0, 0.1)",
    borderRadius: "5px",
    color: "#9A9A9A",
    fontSize: "12px",
    lineHeight: "12px",
    cursor: "pointer",
    padding: "5px",
    border: "1px dashed #ccc",
  },
  buttonText: {
    textTransform: "none",
    color: "#fff",
  },
}));
